document.addEventListener('DOMContentLoaded', function() {
  console.log('Script iniciado - DOM carregado');
  
  // Verificar se estamos na página do produto
  const productForm = document.querySelector('form[action="/cart/add"]');
  if (!productForm) {
    console.error('Formulário de produto não encontrado');
    return;
  }

  // Localizar o produto-variants elemento
  const productVariantsElement = document.querySelector('product-variants');
  if (!productVariantsElement) {
    console.error('Elemento product-variants não encontrado');
    return;
  }

  // Função para atualizar os preços exibidos
  function updateDisplayedPrices(variantId) {
    console.log('Atualizando preços para variante:', variantId);
    
    // Obter o conteúdo do noscript
    const noscript = productVariantsElement.querySelector('noscript');
    if (!noscript) return;
    
    // Criar um elemento temporário para parsear o HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = noscript.textContent;
    
    // Encontrar o select e suas opções
    const select = tempDiv.querySelector('select');
    if (!select) return;
    
    const options = Array.from(select.querySelectorAll('option'));
    if (!options.length) return;
    
    // Encontrar a opção que corresponde ao ID da variante
    const selectedOption = options.find(option => option.value === variantId);
    
    if (!selectedOption) {
      console.warn('Não foi possível encontrar a opção para a variante:', variantId);
      return;
    }
    
    // Extrair informações de preço da opção selecionada
    const optionText = selectedOption.textContent;
    console.log('Texto da opção selecionada:', optionText);
    
    // Extrair o preço (formato esperado: "... - R$ 199,90")
    const priceMatch = optionText.match(/\s-\s(R\$\s[\d.,]+)/);
    
    if (!priceMatch || !priceMatch[1]) {
      console.warn('Não foi possível extrair o preço do texto:', optionText);
      return;
    }
    
    const priceText = priceMatch[1]; // Ex: "R$ 199,90"
    console.log('Preço extraído:', priceText);
    
    // Atualizar os elementos de preço na página
    const priceElement = document.querySelector('.price.price--large, .price.price--highlight.price--large');
    if (priceElement) {
      // Preservar o span visually-hidden
      const span = priceElement.querySelector('.visually-hidden');
      const priceContent = document.createTextNode(priceText);
      
      // Limpar o elemento e reconstruí-lo
      priceElement.innerHTML = '';
      if (span) {
        priceElement.appendChild(span.cloneNode(true));
      }
      priceElement.appendChild(priceContent);
      console.log('Preço principal atualizado:', priceText);
    } else {
      console.warn('Elemento de preço não encontrado');
    }
    
    // Verificar se há um preço de comparação na string (formato: "... - R$ 199,90")
    // Se o preço regular for diferente, significa que há um desconto
    const priceValue = parseFloat(priceText.replace('R$', '').replace('.', '').replace(',', '.').trim());
    
    // Tentar encontrar um preço de comparação no documento (se existir)
    const compareElement = document.querySelector('.price.price--compare');
    if (compareElement) {
      const compareText = compareElement.textContent.trim();
      const compareMatch = compareText.match(/R\$\s*([\d.,]+)/);
      
      if (compareMatch && compareMatch[1]) {
        const compareValue = parseFloat(compareMatch[1].replace('.', '').replace(',', '.'));
        
        // Calcular a porcentagem de desconto
        if (compareValue > priceValue) {
          const discount = Math.round((1 - (priceValue / compareValue)) * 100);
          
          // Atualizar o elemento de desconto se existir
          const discountElement = document.querySelector('.label.label--highlight');
          if (discountElement) {
            discountElement.textContent = discount + '%';
            console.log('Desconto atualizado:', discount + '%');
          }
        }
      }
    }
  }

  // Função para encontrar a variante correspondente
  function findVariantId() {
    try {
      // Obter as opções selecionadas
      const option1 = document.querySelector('input[name="option1"]:checked');
      const option2 = document.querySelector('input[name="option2"]:checked');
      
      if (!option1 || !option2) return null;
      
      const model = option1.value;
      const size = option2.value;
      
      // Obter o conteúdo do noscript
      const noscript = productVariantsElement.querySelector('noscript');
      if (!noscript) return null;
      
      // Converter o texto do noscript para um DOM parseável
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = noscript.textContent;
      
      // Encontrar o select
      const select = tempDiv.querySelector('select');
      if (!select) return null;
      
      const options = select.querySelectorAll('option');
      
      // Procurar a opção que corresponde às seleções
      const searchText = model + ' / ' + size;
      
      for (let i = 0; i < options.length; i++) {
        if (options[i].textContent.includes(searchText)) {
          console.log('Variante correspondente encontrada:', options[i].textContent, 'ID:', options[i].value);
          return options[i].value;
        }
      }
    } catch (e) {
      console.error('Erro ao encontrar variante:', e);
    }
    
    return null;
  }

  // Função para atualizar todos os inputs de ID da variante
  function updateAllVariantInputs(variantId) {
    // Atualizar qualquer input com name="id"
    document.querySelectorAll('input[name="id"]').forEach(input => {
      input.value = variantId;
      input.disabled = false;
      console.log('Input atualizado:', input);
    });
    
    // Se não encontrou nenhum, criar um novo
    if (document.querySelectorAll('input[name="id"]').length === 0) {
      const newInput = document.createElement('input');
      newInput.type = 'hidden';
      newInput.name = 'id';
      newInput.value = variantId;
      productForm.appendChild(newInput);
      console.log('Novo input criado:', newInput);
    }
  }

  // Função para atualizar a variante selecionada
  function updateSelectedVariant() {
    const variantId = findVariantId();
    if (!variantId) {
      console.warn('Não foi possível encontrar um ID de variante correspondente');
      return;
    }

    console.log('ID da variante encontrado:', variantId);
    updateAllVariantInputs(variantId);
    
    // Atualizar os preços exibidos
    updateDisplayedPrices(variantId);
    
    // Armazenar o ID da variante na window para acessos futuros
    window.currentVariantId = variantId;
    console.log('ID da variante definido globalmente:', window.currentVariantId);
  }

  // Interceptar o envio do formulário
  productForm.addEventListener('submit', function(e) {
    // Verificar se temos um ID de variante atual
    if (window.currentVariantId) {
      // Parar o envio normal
      e.preventDefault();
      
      // Atualizar todos os inputs novamente, por garantia
      updateAllVariantInputs(window.currentVariantId);
      
      console.log('Formulário interceptado, atualizando ID da variante para:', window.currentVariantId);
      
      // Permitir um breve atraso para garantir que os inputs sejam atualizados
      setTimeout(() => {
        // Enviar o formulário programaticamente
        console.log('Enviando formulário com ID de variante:', window.currentVariantId);
        
        // Se o tema usa jQuery e AJAX para adicionar ao carrinho
        if (window.jQuery && window.jQuery.ajax) {
          console.log('Usando jQuery AJAX para adicionar ao carrinho');
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(this).serialize(),
            dataType: 'json',
            success: function(response) {
              console.log('Produto adicionado ao carrinho com sucesso:', response);
              // Redirecionar para o carrinho ou atualizar a mini-cart
              window.location.href = '/cart';
            },
            error: function(error) {
              console.error('Erro ao adicionar ao carrinho:', error);
              this.submit(); // Tenta envio normal como fallback
            }
          });
        } else {
          // Envio tradicional de formulário
          console.log('Usando envio tradicional de formulário');
          this.submit();
        }
      }, 100);
    }
  });

  // Monitorar alterações nas opções
  document.querySelectorAll('input[name="option1"], input[name="option2"]').forEach(option => {
    option.addEventListener('change', function() {
      console.log('Opção alterada:', this.name, 'Valor:', this.value);
      updateSelectedVariant();
    });
  });

  // Inicializar com as opções iniciais
  if (document.querySelector('input[name="option1"]:checked') && 
      document.querySelector('input[name="option2"]:checked')) {
    updateSelectedVariant();
  } else {
    setTimeout(updateSelectedVariant, 500);
  }
  
  // Adicionar um log para quando o botão de adicionar ao carrinho for clicado
  const addToCartButton = document.querySelector('button[type="submit"][data-product-add-to-cart-button]');
  if (addToCartButton) {
    addToCartButton.addEventListener('click', function() {
      console.log('Botão adicionar ao carrinho clicado. ID da variante atual:', window.currentVariantId);
    });
  }
});